$(function() {
    const swiperEvents = new Swiper('.events-swiper', {
        allowTouchMove: false,
        slidesPerView: 1,
        spaceBetween: 10,
        effect: 'fade',
        autoHeight: true,
        fadeEffect: {
            crossFade: true,
        },

    });

    $(document).on('mouseover', '.archive-container', function() {
        const projectNumber = $(this).data('project');
        $('.archive-container').removeClass('active');
        $(this).addClass('active');
        swiperEvents.slideTo(projectNumber - 1);
        swiperEvents.updateAutoHeight(300);
    });


});

document.addEventListener('DOMContentLoaded', function () {
    const sortDateLink = document.getElementById('sort-date');
    const sortAlphaLink = document.getElementById('sort-alphabet');
    const sortTypeLink = document.getElementById('sort-type');
    const archiveList = document.querySelector('.archive-list');
    const archiveContainers = Array.from(document.querySelectorAll('.archive-container'));
  
    let dateAsc = true;
    let alphaAsc = true;
    let typeAsc = true;

    // Capture initial translated text (and strip any default arrows if present)
    const dateLabel = sortDateLink.textContent.replace(/[↑↓]/g, '').trim();
    const alphaLabel = sortAlphaLink.textContent.replace(/[↑↓]/g, '').trim();
    const typeLabel = sortTypeLink.textContent.replace(/[↑↓]/g, '').trim();
  
    // Utility: Reset link states
    function resetSortLinks() {
      [sortDateLink, sortAlphaLink, sortTypeLink].forEach(link => {
        link.classList.remove('opacity-100');
        link.classList.add('opacity-6');
      });
  
      sortDateLink.innerHTML = dateLabel;
      sortAlphaLink.innerHTML = alphaLabel;
      sortTypeLink.innerHTML = typeLabel;
    }
  
    // Utility: Sort DOM elements
    function sortArchive(compareFn) {
      const sorted = [...archiveContainers].sort(compareFn);
      archiveList.innerHTML = ''; // Clear current list
      sorted.forEach(el => archiveList.appendChild(el));
    }
  
    // Date sorting
    sortDateLink.addEventListener('click', function (e) {
      e.preventDefault();
      resetSortLinks();
      sortDateLink.classList.remove('opacity-6');
      sortDateLink.classList.add('opacity-100');
      sortDateLink.innerHTML = dateAsc ? `${dateLabel} ↑` : `${dateLabel} ↓`;
  
      sortArchive((a, b) => {
        const dateA = new Date(a.dataset.date);
        const dateB = new Date(b.dataset.date);
        return dateAsc ? dateA - dateB : dateB - dateA;
      });
  
      dateAsc = !dateAsc;
    });
  
    // Alphabet sorting
    sortAlphaLink.addEventListener('click', function (e) {
      e.preventDefault();
      resetSortLinks();
      sortAlphaLink.classList.remove('opacity-6');
      sortAlphaLink.classList.add('opacity-100');
      sortAlphaLink.innerHTML = alphaAsc ? `${alphaLabel} ↑` : `${alphaLabel} ↓`;
  
      sortArchive((a, b) => {
        const titleA = a.dataset.title.toLowerCase();
        const titleB = b.dataset.title.toLowerCase();
        if (titleA < titleB) return alphaAsc ? -1 : 1;
        if (titleA > titleB) return alphaAsc ? 1 : -1;
        return 0;
      });
  
      alphaAsc = !alphaAsc;
    });

    // Type sorting
    sortTypeLink.addEventListener('click', function (e) {
      e.preventDefault();
      resetSortLinks();
      sortTypeLink.classList.remove('opacity-6');
      sortTypeLink.classList.add('opacity-100');
      sortTypeLink.innerHTML = typeAsc ? `${typeLabel} ↑` : `${typeLabel} ↓`;
  
      sortArchive((a, b) => {
        const typeA = a.dataset.type.toLowerCase();
        const typeB = b.dataset.type.toLowerCase();
        if (typeA < typeB) return typeAsc ? -1 : 1;
        if (typeA > typeB) return typeAsc ? 1 : -1;
        return 0;
      });
  
      typeAsc = !typeAsc;
    });
  
    // Initial state
    resetSortLinks();    
    sortDateLink.click(); // Trigger sort by date ASC on load

    // Trigger mouseover on the first item in the sorted list to sync Swiper and active class
    const firstContainer = archiveList.querySelector('.archive-container');
    if (firstContainer) {
      const mouseOverEvent = new MouseEvent('mouseover', {
        bubbles: true,
        cancelable: true,
        view: window
      });
      firstContainer.dispatchEvent(mouseOverEvent);
    }

    const monthSelect = document.getElementById('month-select');
    const monthContainers = document.querySelectorAll('.container-month');

    monthSelect.addEventListener('change', function () {
      const selected = this.value;
      console.log(selected);
      monthContainers.forEach(container => {
        const month = container.dataset.month;
        if (selected === 'all' || month === selected) {
          container.style.display = '';
        } else {
          container.style.display = 'none';
        }
      });
    });
});